<template>
  <span v-if="hasAnyGroup || $slots['no-groups']">
    <slot v-if="hasAnyGroup" />
    <slot v-else name="no-groups" />
  </span>
</template>

<script setup>
import { computed } from "vue";
import store from "@/store";

const props = defineProps({
  groups: {
    type: Array,
    required: true,
  },
});
const hasAnyGroup = computed(() => store.getters.hasAnyGroup(props.groups));
</script>
